import { render, staticRenderFns } from "./clarification.vue?vue&type=template&id=1f89cb52&scoped=true"
import script from "./clarification.vue?vue&type=script&lang=js"
export * from "./clarification.vue?vue&type=script&lang=js"
import style0 from "./clarification.vue?vue&type=style&index=0&id=1f89cb52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f89cb52",
  null
  
)

export default component.exports